import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './styles.less';

/**
 * A component that wraps its children in a container with a max width
 * applied. By default, the max width is 1920px which can be used to
 * keep sections from expanding beyond a reasonable width on the page.
 * This component also has some simple padding applied to it.
 */
export const PageContainer = ( props ) => {
    // Construct the classes to use for the root component.
    const classes = classnames(
        'page-container',
        { 'center': Boolean( props.center ) },
        { [ props.className ]: Boolean( props.className ) },
    );

    return (
        <div className={ classes } style={ {
            maxWidth: props.maxWidth,
            ...props.style
        } }>
            { props.children }
        </div>
    );
};

PageContainer.defaultProps = {
    center: true,
    maxWidth: '1920px',
};

PageContainer.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    center: PropTypes.bool,
    maxWidth: PropTypes.oneOfType( [ PropTypes.string, PropTypes.number ] ),
};
